<app-header (returnLoggedUser)="userData = $event"></app-header>
<div class="full-page credit-letter">
    <div class="card">
        <div class="header">
            <div class="title-back">
                <mat-icon *ngIf="showBackIcon" fontSet="material-icons-round" class="arrow-back" routerLink="/credit-conversion/panel">arrow_back</mat-icon>
                <h1 class="title">{{ 'creditLetter.title' | translate }}</h1>
                <mat-icon fontSet="material-icons-round" (click)="openHowItWorks()" [matTooltip]="'creditLetter.howWorks' | translate" matTooltipClass="tooltip-primary" class="help-icon">help_outline</mat-icon>
            </div>
            <app-token-information></app-token-information>
        </div>

        <router-outlet></router-outlet>
    </div>

    <mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
</div>
